import { useValidity } from "customization/templates/FieldTemplate/FieldTemplate";
import React from "react";
import FormInput from "../../ui/FormInput/FormInput";

/**
 * This is a modifed version of the core widget
 * See https://github.com/mozilla-services/react-jsonschema-form/blob/v1.2.0/src/components/widgets/BaseInput.js
 */
const BaseInput = ({
  id,
  value,
  readonly,
  disabled,
  autofocus,
  onBlur,
  onFocus,
  options,
  registry,
  rawErrors,
  onChange,
  uiSchema,
  ...inputProps
}) => {
  inputProps.type = options.inputType || inputProps.type || "text";
  const _onChange = ({ target: { value } }) => {
    return onChange(value === "" ? options.emptyValue : value);
  };
  const { isInvalid, handleOnBlur } = useValidity();
  delete inputProps.formContext; // Avoid bug

  return (
    <FormInput
      id={id}
      readOnly={readonly}
      disabled={disabled}
      autoFocus={autofocus}
      invalid={isInvalid}
      // invalid={rawErrors && rawErrors.length > 0 && isDirty ? true : false}
      value={value == null ? "" : value}
      onChange={_onChange}
      onBlur={
        onBlur &&
        ((event) => {
          handleOnBlur();
          onBlur(id, event.target.value);
        })
      }
      onFocus={onFocus && ((event) => onFocus(id, event.target.value))}
      sessionCamExclude={!options.sessioncamInclude}
      {...inputProps}
    />
  );
};

export default BaseInput;
